import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { debounce } from "lodash";
import Heading from "../../../../../../common/element/Heading/index.js";
import BtnLight from "../../../../../../common/element/Buttons/btnLight.js";
import Dropdown from "../../../../../../common/element/Dropdown/Dropdown.js";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice.js";
// import PieChart from "../ProviderUnderAClient/PieChartUnderAClient.js";
import XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ActivityGauge from "./ActivityGauge.js";
import ProgressCircle from "./ProgressCircle.js";
import ClientInductionList from "./DataList.js";
import { Pagination } from "../../../../../../common/pagination/index.js";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler.js";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader/index.js";
import ThreeDotLoader from "../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import { notify } from "react-notify-toast";
import ReactPaginate from "react-paginate";
import ClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientMultiSelectDropdown.js";
import StatusMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/StatusMultiSelectDropdown.js";
import DateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/DateMultiSelectDropdown.js";
import ProviderMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ProviderMultiSelectDropdown.js";
import SiteMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/SiteMultiSelectDropdown.js";
import InductionMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/InductionMultiSelectDropdown.js";
import MainOfficeStateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/MainOfficeStateMultiSelectDropdown.js";
import ServiceMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ServiceMultiSelectDropdown.js";
import moment from "moment";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary.js";
import Input from "../../../../../../common/element/Input/Input.js";
import { ProviderGetAllfavouriteReports, ProviderFavouriteReportsOrNot } from "../../../../../../actions/admin-provider/worker/ProviderReportFavOrNot";
import { FetchAllProviderCustomReports, ProviderCustomReports } from "../../../../../../actions/admin-provider/reports/CustomReportForProvider";
import { useLocation, useNavigate } from "react-router-dom";

import { CSVLink } from "react-csv";
import logoPDF from "./LogoPDF.png";
import Dialog from "../../../../../../common/element/Dialog/Dialog.js";
import {
  GenerateProviderChecklistOverviewReport,
  TriggerProviderChecklistReport,
} from "../../../../../../actions/admin-provider/reports/GenerateProviderChecklistOverviewReport.js";
import DataList from "./DataList.js";
import CheckListMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/CheckListMultiSelectDropdown.js";
import * as actionType from "../../../../../../constant/actionType.js";

const formatAmountInsured = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "-";
  const s = String(raw).trim();
  if (!s || s === "-") return "-";

  const cleaned = s.replace(/[$,\s]/g, "");
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return s.startsWith("$") ? s : `$${s}`;

  const formatted = n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${formatted}`;
};

const normalizeDocCategoryLabel = (raw) => {
  const s = (raw || "").toString().trim();
  const sl = s.toLowerCase();
  if (sl === "licenses" || sl === "licences") return "Licenses";
  if (sl === "insurances" || sl === "insurance") return "Insurances";
  if (sl === "whs") return "WHS";
  if (sl === "info" || sl === "information") return "Info";
  return s ? s : "Others";
};

const groupDocsForExport = (docs) => {
  const safeDocs = Array.isArray(docs) ? docs : [];
  const groups = new Map();
  safeDocs.forEach((d) => {
    // Check if document has document_type_id 1 or 3 for Company Registration category
    if (d?.document_type_id === "1" || d?.document_type_id === "3" || d?.document_type_id === 1 || d?.document_type_id === 3) {
      const label = "Company Registration";
      const arr = groups.get(label) || [];
      arr.push(d);
      groups.set(label, arr);
    } else {
      const label = normalizeDocCategoryLabel(d?.doc_category);
      const arr = groups.get(label) || [];
      arr.push(d);
      groups.set(label, arr);
    }
  });

  const coreOrder = ["Licenses", "Insurances", "WHS", "Info", "Company Registration"];
  const labels = Array.from(groups.keys());
  const otherLabels = labels
    .filter((l) => l !== "Others" && !coreOrder.includes(l))
    .sort((a, b) => a.localeCompare(b));
  const orderedLabels = [
    ...coreOrder.filter((l) => groups.has(l)),
    ...otherLabels,
    ...(groups.has("Others") ? ["Others"] : []),
  ];

  return orderedLabels.map((label) => ({ label, rows: groups.get(label) || [] }));
};

const parseDocTypeFields = (fields) => {
  if (!fields) return {};
  if (typeof fields === "object") return fields;
  if (typeof fields === "string") {
    try {
      return JSON.parse(fields);
    } catch (e) {
      return {};
    }
  }
  return {};
};

const getDocNameForExport = (doc) =>
  doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-");

const getIssuingAuthorityForExport = (doc) => {
  const direct = doc?.issuing_authority || doc?.issuer;
  if (direct && String(direct).trim()) return String(direct).trim();

  const fields = parseDocTypeFields(doc?.doctype_fields_data);
  const fromFields =
    fields?.Issuer ||
    fields?.issuer ||
    fields?.issuing_authority ||
    fields?.issuingAuthority;
  if (fromFields && String(fromFields).trim()) return String(fromFields).trim();
  return "-";
};

const getApprovalDateForExport = (doc) => {
  const fields = parseDocTypeFields(doc?.doctype_fields_data);
  const approvalFromFields =
    fields?.approvalDate ||
    fields?.ApprovalDate ||
    fields?.approval_date_v2 ||
    fields?.approvalDateV2 ||
    fields?.ApprovalDateV2;
  return doc?.reviewed_date || doc?.approval_date_v2 || approvalFromFields || null;
};

const getIssueDateForExport = (doc) => {
  const fields = parseDocTypeFields(doc?.doctype_fields_data);
  const issueFromFields =
    fields?.issuedate ||
    fields?.IssueDate ||
    fields?.issueDate ||
    fields?.issue_date ||
    fields?.Issue_Date ||
    fields?.valid_from ||
    fields?.ValidFrom ||
    fields?.validFrom;
  return issueFromFields || doc?.issue_date || null;
};

const getDocExpiryForExport = (doc) => {
  const exp = doc?.doc_expiry_date ?? doc?.expiry_date ?? null;
  if (exp === "-" || exp === "" || exp === undefined) return null;
  return exp;
};

const getValidFromForExport = (doc) => {
  const fields = parseDocTypeFields(doc?.doctype_fields_data);
  return (
    fields?.ValidFrom ||
    fields?.valid_from ||
    fields?.validFrom ||
    fields?.IssueDate ||
    fields?.issueDate ||
    fields?.issuedate ||
    null
  );
};

const getValidToForExport = (doc) => {
  return doc?.expiry_date || doc?.doc_expiry_date || null;
};

const ProvidersComplianceChecklist = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const { favReport, cstRep } = location.state || {};
  const [selectReport, setSelectReport] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false)
  const [saveCustomRep, setSaveCustomRep] = useState(false)
  const [unSaveDialogIsOpen, unSaveSetIsOpen] = useState(false);
  const [removeDilaog, setRemoveDialog] = useState(false);
  const [custReportName, setCustReportName] = useState("")
  const [custSuccessMsg, setCustSuccessMsg] = useState(false);
  const [custErrMsg, setCustErrMsg] = useState("")

  const csvLinkRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const handleUnauthorizedAccessRef = useRef(handleUnauthorizedAccess);
  useEffect(() => {
    handleUnauthorizedAccessRef.current = handleUnauthorizedAccess;
  }, [handleUnauthorizedAccess]);
  const dispatch = useDispatch();
  const [reportData, SetReportData] = useState(null);
  const [loadData, setLoadData] = useState(false);
  const [processedCsvData, setProcessedCsvData] = useState([]);
  const [checkPdfLoad, setCheckPdfLoad] = useState(true);
  const [successText, setSuccessText] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [key, setKey] = useState("custom");
  const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
    useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState(new Set());
  const [rowDetailsMap, setRowDetailsMap] = useState({});
  const [rowDetailsLoading, setRowDetailsLoading] = useState({});
  const [currentCsvHeaders, setCurrentCsvHeaders] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(new Set());
  const [providerDocsByOrgId, setProviderDocsByOrgId] = useState({});
  const [providerDocsLoadingByOrgId, setProviderDocsLoadingByOrgId] = useState({});

  const [dateMinMax, setDateMinMax] = useState({
    lowestDate: null,
    greatestDate: null,
  });
  const [refreshKey, setRefreshKey] = useState(0); // added
  const [getAllinvitedData, SetgetAllinvitedData] = useState({
    search: "",
    client_org_ids: [],
    provider_org_ids: [],
    checklist_ids: [],
    status: "",
    never_uploaded: false,
    provider_status: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    completion_date_range: "",
    client_contact_name: "",
  });
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  let userType;
  let userId;
  if (storedData) {
    userId = storedData?.userName?.user_id;
    userType = storedData?.data?.role?.role_name
  }
  const updateReportState = useCallback((payload = {}, filters = {}) => {
    let docs = Array.isArray(payload?.DocsReport) ? payload.DocsReport : [];

    const computeAvgCompletionRate = (items) => {
      const safeItems = Array.isArray(items) ? items : [];
      if (safeItems.length === 0) return 0;
      const nums = safeItems
        .map((it) => Number(it?.completion_rate))
        .filter((v) => Number.isFinite(v));
      if (nums.length === 0) return 0;
      const sum = nums.reduce((a, b) => a + b, 0);
      return sum / nums.length;
    };

    const isNeverUploaded = (it) => {
      return Number(it?.total_checklist_docs || 0) === 0;
    };

    if (filters?.never_uploaded) {
      docs = docs.filter(isNeverUploaded);
    }

    const buildStatusStats = (items) => {
      const acc = {
        approved: 0,
        awaiting_review: 0,
        action_required: 0,
        partial: 0,
        never_uploaded: 0,
        totalCount: 0,
      };

      (items || []).forEach((it) => {
        if (isNeverUploaded(it)) {
          acc.never_uploaded += 1;
        }

        const s = (it?.status || "").toString().trim().toLowerCase();
        if (s === "approved") acc.approved += 1;
        else if (s === "awaiting review" || s === "awaiting_review") acc.awaiting_review += 1;
        else if (s === "action required" || s === "action_required") acc.action_required += 1;
        else if (s === "partial") acc.partial += 1;
        else if (s) acc.action_required += 1;

        acc.totalCount += 1;
      });

      return acc;
    };

    const recomputedStaticsGraph = {
      ...(payload?.staticsGraph || {}),
      ...buildStatusStats(docs),
      avg_completion_rate: computeAvgCompletionRate(docs),
    };

    const isClientSideFiltered = !!filters?.never_uploaded;
    const effectiveTotal = isClientSideFiltered
      ? docs.length
      : (Number(payload?.total) || docs.length);

    SetReportData({
      ...payload,
      DocsReport: docs,
      staticsGraph: recomputedStaticsGraph,
      total: effectiveTotal,
    });

    // Selection is only for current list; clear when list changes.
    setSelectedRowKeys(new Set());

    // Provider docs cache is tied to current result set; clear when list changes.
    setProviderDocsByOrgId({});
    setProviderDocsLoadingByOrgId({});

    const timestamps = docs
      .map((product) => new Date(product?.date_joined).getTime())
      .filter((value) => !Number.isNaN(value));

    if (timestamps.length > 0) {
      setDateMinMax({
        lowestDate: new Date(Math.min(...timestamps)),
        greatestDate: new Date(Math.max(...timestamps)),
      });
    } else {
      setDateMinMax({ lowestDate: null, greatestDate: null });
    }

    const limit = Number(filters?.limit) || docs.length || 1;
    setTotalPages(Math.ceil(effectiveTotal / limit));
  }, []);

  const buildRowKey = useCallback((item) => {
    const a = item?.provider_org_id ?? item?.provider_trading_name ?? "";
    const b = item?.client_org_id ?? item?.client_trading_name ?? "";
    const c = item?.checklist_id ?? item?.checklist_name ?? "";
    return `${a}|${b}|${c}`;
  }, []);

  const onToggleRow = useCallback((item) => {
    const key = buildRowKey(item);
    setSelectedRowKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  }, [buildRowKey]);

  const fetchAllProviderDocs = useCallback(async (organisation_id) => {
    const orgId = organisation_id ? String(organisation_id) : "";
    if (!orgId) return [];

    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/provider/GetAllDocumentsOfProvider`,
        params: {
          organisation_id: orgId,
          page: 1,
          limit: 10000,
          sort: "created_date",
          order: "desc",
          search: "",
        },
      });

      if (response?.data?.status === 200 && response?.data?.success) {
        const payload = response?.data?.data;
        // GETSUCCESS wraps Sequelize findAndCountAll => { count, rows }
        const docs = Array.isArray(payload?.rows) ? payload.rows : Array.isArray(payload) ? payload : [];
        return docs;
      }

      if (response?.status === 401) {
        handleUnauthorizedAccessRef.current?.();
      }

      return [];
    } catch (e) {
      if (e?.response?.status === 401) {
        handleUnauthorizedAccessRef.current?.();
      }
      return [];
    }
  }, []);

  const fetchWorkersForProviderClient = useCallback(async (provider_org_id, client_org_id) => {
    const providerId = provider_org_id ? String(provider_org_id) : "";
    const clientId = client_org_id ? String(client_org_id) : "";
    if (!providerId || !clientId) return [];

    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/provider/GetAllAssignedWorkerToClient`,
        params: {
          provider_org_id: providerId,
          client_org_id: clientId,
          sort: "created_date",
          order: "desc",
        },
      });

      if (response?.data?.status === 200 && response?.data?.success) {
        return Array.isArray(response?.data?.data) ? response.data.data : [];
      }

      if (response?.status === 401) {
        handleUnauthorizedAccessRef.current?.();
      }
      return [];
    } catch (e) {
      if (e?.response?.status === 401) {
        handleUnauthorizedAccessRef.current?.();
      }
      return [];
    }
  }, []);


  const fetchWorkerDocsForProviderClient = useCallback(async (provider_org_id, client_org_id) => {
    const workers = await fetchWorkersForProviderClient(provider_org_id, client_org_id);
    if (!workers.length) return [];

    const docPromises = workers.map(async (worker) => {
      try {
        const workerId = worker?.worker_id;
        const individualId = worker?.individual_id;
        if (!workerId || !individualId) return [];

        const response = await axios({
          method: "get",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          },
          url: `${actionType.environment_url}/api/admin/worker/GetAllDocsOfWorker`,
          params: {
            individual_id: individualId,
            page: 1,
            limit: 1000,
            sort: "doc_name",
            order: "asc",
          },
        });

        const workerName = `${worker?.first_name || ""} ${worker?.last_name || ""}`.trim() || "-";
        const occupation = worker?.worker_job_title || "-";
        const employeeIdRaw = worker?.employee_id_v2;
        const displayWorkerId = employeeIdRaw ? `E-${employeeIdRaw}` : `E-${workerId}`;

        const transformed = [];

        // Check if worker has any documents
        if (response?.data?.status === 200 && response?.data?.success) {
          const docs = Array.isArray(response?.data?.data?.rows) ? response.data.data.rows : [];

          docs.forEach((doc) => {
            transformed.push({
              worker_id: workerId,
              employee_id_v2: employeeIdRaw || null,
              display_worker_id: displayWorkerId,
              worker_name: workerName,
              occupation,
              certification_name: doc?.doc_name || "-",
              doc_type_name: doc?.doc_type_name || "-",
              issuing_authority: doc?.issuer || "-",
              valid_from: getValidFromForExport(doc),
              valid_to: doc?.expiry_date || null,
              approval_status: "approved",
              document_id: doc?.document_id,
            });
          });
        }

        // IMPORTANT: If worker has no documents, still include them with default values
        if (transformed.length === 0) {
          transformed.push({
            worker_id: workerId,
            employee_id_v2: employeeIdRaw || null,
            display_worker_id: displayWorkerId,
            worker_name: workerName,
            occupation,
            certification_name: "-",
            doc_type_name: "-",
            issuing_authority: "-",
            valid_from: null,
            valid_to: null,
            approval_status: "No Documents",
            document_id: null,
          });
        }

        return transformed;
      } catch (e) {
        if (e?.response?.status === 401) {
          handleUnauthorizedAccessRef.current?.();
        }
        // Even on error, include the worker with default values
        const workerName = `${worker?.first_name || ""} ${worker?.last_name || ""}`.trim() || "-";
        const occupation = worker?.worker_job_title || "-";
        const employeeIdRaw = worker?.employee_id_v2;
        const displayWorkerId = employeeIdRaw ? `E-${employeeIdRaw}` : `E-${worker?.worker_id}`;

        return [{
          worker_id: worker?.worker_id,
          employee_id_v2: employeeIdRaw || null,
          display_worker_id: displayWorkerId,
          worker_name: workerName,
          occupation,
          certification_name: "-",
          doc_type_name: "-",
          issuing_authority: "-",
          valid_from: null,
          valid_to: null,
          approval_status: "No Documents",
          document_id: null,
        }];
      }
    });

    const all = await Promise.all(docPromises);
    const flattened = all.flat();

    // Deduplication logic to remove duplicate document entries for workers
    // while keeping workers without documents (document_id: null)
    const seen = new Set();
    const deduped = [];
    flattened.forEach((doc) => {
      const docId = doc?.document_id;
      // Only deduplicate if document_id exists. If null, it's a 'No Documents' entry, which should be kept.
      if (docId && seen.has(docId)) return;
      if (docId) seen.add(docId);
      deduped.push(doc);
    });

    return deduped;
  }, [fetchWorkersForProviderClient]);

  // Frontend-only: expand/collapse. Placeholder for details; backend wiring to be added later.
  const onToggleExpand = useCallback((item) => {
    const key = buildRowKey(item);
    const orgId = item?.provider_org_id ?? item?.provider_id;

    setExpandedRowKeys((prev) => {
      const s = new Set(prev);
      if (s.has(key)) s.delete(key); else s.add(key);
      return s;
    });

    // Fetch provider documents for the accordion (match Specific Provider -> Documents)
    if (orgId !== null && orgId !== undefined) {
      // OLD: const orgKey = String(orgId); // This caused collision for same provider with different clients/checklists
      // NEW: Use full context key to prevent caching collision
      const contextKey = key; // Use the same key as buildRowKey: provider|client|checklist

      const alreadyLoaded = Array.isArray(providerDocsByOrgId?.[contextKey]);
      const alreadyLoading = Boolean(providerDocsLoadingByOrgId?.[contextKey]);

      if (!alreadyLoaded && !alreadyLoading) {
        setProviderDocsLoadingByOrgId((prev) => ({ ...prev, [contextKey]: true }));
        fetchAllProviderDocs(orgId) // Fixed: use orgId instead of orgKey
          .then((docs) => {
            setProviderDocsByOrgId((prev) => ({ ...prev, [contextKey]: docs }));
          })
          .finally(() => {
            setProviderDocsLoadingByOrgId((prev) => ({ ...prev, [contextKey]: false }));
          });
      }
    }

    // If not loaded/known, set an empty list placeholder (can replace with API call later)
    setRowDetailsMap((prev) => {
      if (prev[key]) return prev;
      return { ...prev, [key]: { items: [], loaded: true } };
    });
  }, [buildRowKey, fetchAllProviderDocs, providerDocsByOrgId, providerDocsLoadingByOrgId]);

  // If filters change while a row is expanded, the provider docs cache is cleared in updateReportState.
  // This effect ensures we re-fetch provider documents for any still-expanded rows so the user
  // doesn't need to collapse/re-open the accordion.
  useEffect(() => {
    if (!expandedRowKeys || expandedRowKeys.size === 0) return;
    const list = Array.isArray(reportData?.DocsReport) ? reportData.DocsReport : [];
    if (list.length === 0) return;

    expandedRowKeys.forEach((rowKey) => {
      const row = list.find((it) => buildRowKey(it) === rowKey);
      if (!row) return;

      const orgId = row?.provider_org_id ?? row?.provider_id;
      if (orgId === null || orgId === undefined) return;

      const contextKey = rowKey;
      const alreadyLoaded = Array.isArray(providerDocsByOrgId?.[contextKey]);
      const alreadyLoading = Boolean(providerDocsLoadingByOrgId?.[contextKey]);
      if (alreadyLoaded || alreadyLoading) return;

      setProviderDocsLoadingByOrgId((prev) => ({ ...prev, [contextKey]: true }));
      fetchAllProviderDocs(orgId)
        .then((docs) => {
          setProviderDocsByOrgId((prev) => ({ ...prev, [contextKey]: docs }));
        })
        .finally(() => {
          setProviderDocsLoadingByOrgId((prev) => ({ ...prev, [contextKey]: false }));
        });
    });
  }, [
    expandedRowKeys,
    reportData?.DocsReport,
    buildRowKey,
    fetchAllProviderDocs,
    providerDocsByOrgId,
    providerDocsLoadingByOrgId,
  ]);


  const fetchProviderChecklistOverview = useCallback(
    async (filters) => {
      if (!filters) return null;
      setLoadData(false);

      try {
        const response = await dispatch(
          GenerateProviderChecklistOverviewReport(buildApiFilters(filters))
        );

        if (response?.success) {
          updateReportState(response?.data, filters);
        } else if (response?.status === 401) {
          handleUnauthorizedAccessRef.current?.();
        }

        return response;
      } catch (error) {
        console.error("❌ Error fetching provider checklist overview:", error);
        return null;
      } finally {
        setLoadData(true);
      }
    },
    [dispatch, updateReportState]
  );

  const latestFiltersRef = useRef(null);
  const loadingTimeoutRef = useRef();

  useEffect(() => {
    const stringifiedFilters = JSON.stringify({ ...getAllinvitedData, _rk: refreshKey });

    if (latestFiltersRef.current === stringifiedFilters) {
      return;
    }

    latestFiltersRef.current = stringifiedFilters;

    clearTimeout(loadingTimeoutRef.current);

    const filtersSnapshot = JSON.parse(stringifiedFilters);

    loadingTimeoutRef.current = setTimeout(() => {
      fetchProviderChecklistOverview(filtersSnapshot);
    }, 150);

    return () => clearTimeout(loadingTimeoutRef.current);
  }, [getAllinvitedData, fetchProviderChecklistOverview, refreshKey]); // added the refresh key to dependency array

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Reports",
          url: "/admin/reports",
          home: "/admin/provider/dashboard",
        },
        {
          label: "Provider Summary Report",
          url: "/admin/provider/reports/compliance-checklist",
        },
      ])
    );
  }, [dispatch]);
  const handleSort = (empty, column) => {
    // if (column === getAllinvitedData.sort) {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        ["sort"]: column,
      };
    });
  };

  const handlePageChange = ({ selected }) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["page"]: selected + 1,
      };
    });
  };

  const updateFilter = (fieldName, value) => {
    SetgetAllinvitedData((prevalue) => {
      const normalize = (input) => {
        if (Array.isArray(input)) {
          return input
            .map((item) => {
              if (item && typeof item === "object") {
                if (fieldName === "client_org_ids") return item?.organisation_id ?? item;
                if (fieldName === "provider_org_ids") return item?.provider_org_id ?? item;
                if (fieldName === "checklist_ids") return item?.checklist_id ?? item;
                if (fieldName === "site_ids") return item?.site_id ?? item;
              }
              return item;
            })
            .filter((entry) => entry !== undefined && entry !== null);
        }
        return input;
      };

      const previousNormalized = normalize(prevalue[fieldName] ?? []);
      const nextNormalized = normalize(value ?? []);
      const hasFiltersChanged =
        Array.isArray(previousNormalized) || Array.isArray(nextNormalized)
          ? JSON.stringify(previousNormalized) !== JSON.stringify(nextNormalized)
          : prevalue[fieldName] !== value;

      if (!hasFiltersChanged) {
        return prevalue;
      }

      const nextState = {
        ...prevalue,
        [fieldName]: value,
        ["page"]: hasFiltersChanged && fieldName !== "page" ? 1 : prevalue.page,
        ["limit"]:
          fieldName === "limit" && typeof value === "number" ? value : prevalue.limit,
      };

      if (fieldName === "client_org_ids") {
        nextState.provider_org_ids = [];
        nextState.checklist_ids = [];
      }

      if (fieldName === "provider_org_ids") {
        nextState.checklist_ids = [];
      }

      return nextState;
    });

  };

  const debouncedContactNameSearch = useCallback(
    debounce((val) => {
      updateFilter("client_contact_name", val);
    }, 500),
    []
  );

  const buildApiFilters = useCallback((filters) => {
    const out = { ...(filters || {}) };

    if (out?.never_uploaded) {
      out.status = "";
    }

    delete out.never_uploaded;
    return out;
  }, []);

  const generateProviderChecklistOverview = async () => {
    try {
      setIsGenerating(true);
      setLoadData(false);
      const response = await dispatch(
        TriggerProviderChecklistReport(buildApiFilters(getAllinvitedData))
      );
      if (response?.status === 401) {
        handleUnauthorizedAccessRef.current?.();
        notify.show(
          "Unable to generate report due to authorization error.",
          "error",
          3000
        );
        return;
      }

      if (response?.message || response?.success) {
        const successMessage = "Provider Summary report generated successfully";

        const refreshed = await fetchProviderChecklistOverview(
          getAllinvitedData
        );

        if (refreshed?.success) {
          notify.show(successMessage, "success", 3000);
        } else if (refreshed?.status === 401) {
          handleUnauthorizedAccessRef.current?.();
          notify.show(
            "Unable to refresh data due to authorization error.",
            "error",
            3000
          );
        } else {
          notify.show(
            "Unable to refresh report data. Please try again.",
            "error",
            3000
          );
        }
      } else {
        console.error(
          "⚠️ Failed to trigger provider checklist report generation"
        );
        notify.show(
          "Unable to generate report. Please try again.",
          "error",
          3000
        );
      }
    } catch (error) {
      console.error("❌ Error triggering provider checklist report:", error);
      notify.show(
        "Error generating report. Please try again.",
        "error",
        3000
      );
    } finally {
      setIsGenerating(false);
      setLoadData(true);
    }
  };
  const GetPDFAllData = async () => {
    setPdfDownloadSuccessDialog(true);
    // For export, build payload with ALL filters that UI uses to ensure exact matching
    // Note: never_uploaded filtering will be applied client-side after data is fetched
    let Payload = {
      search: getAllinvitedData?.search || "",
      client_org_ids: getAllinvitedData?.client_org_ids || [],
      provider_org_ids: getAllinvitedData?.provider_org_ids || [],
      checklist_ids: getAllinvitedData?.checklist_ids || [],
      status: getAllinvitedData?.status || "",
      provider_status: getAllinvitedData?.provider_status || "",
      site_ids: getAllinvitedData?.site_ids || [], // Added missing site_ids filter
      sort: getAllinvitedData?.sort || "created_date",
      order: getAllinvitedData?.order || "desc",
      completion_date_range: getAllinvitedData?.completion_date_range || getAllinvitedData?.publish_date_range || "",
      // Note: never_uploaded is handled client-side, don't include in payload
    };

    try {
      const response = await dispatch(
        GenerateProviderChecklistOverviewReport(Payload)
      );
      if (response.success) {
        setPdfDownloadSuccessDialog(true);
        return response.data; // Return the response data
      } else if (response?.status === 401) {
        const unauthorizedHandler = handleUnauthorizedAccessRef.current;
        if (typeof unauthorizedHandler === 'function') {
          unauthorizedHandler();
        }
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
      setPdfDownloadSuccessDialog(true);
    } finally {
      setPdfDownloadSuccessDialog(true);
    }
    return null; // Return null if the request is not successful
  };

  const csvHeaders = [
    { label: "Provider ID", key: "provider_org_id" },
    { label: "Provider Name", key: "provider_trading_name" },
    { label: "ABN", key: "provider_abn_nzbn" },
    { label: "Checklist", key: "checklist_name" },
    { label: "Client name", key: "client_trading_name" },
    { label: "Client Contact", key: "client_contact" },
    { label: "Client Contact Email", key: "client_contact_email" },
    { label: "Documents no.", key: "total_checklist_docs" },
    { label: "Completion rate", key: "completion_rate" },
    { label: "Completion date", key: "completion_date" },
  ];

  const docCsvHeaders = [
    { label: "Provider Name", key: "provider_trading_name" },
    { label: "Checklist", key: "checklist_name" },
    { label: "Client name", key: "client_trading_name" },
    { label: "Document", key: "document_display_name" },
    { label: "Issue date", key: "issue_date" },
    { label: "Expiry date", key: "doc_expiry_date" },
  ];

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  function getBase64ImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  const buildDocumentRows = (rows) => {
    const out = [];
    (rows || []).forEach((item) => {
      const docs = Array.isArray(item.documents) ? item.documents : [];
      docs.forEach((doc) => {
        const document_display_name =
          doc?.doc_name || (doc?.is_other_doc ? (doc?.other_doc_name || "-") : "-");
        out.push({
          provider_trading_name: item?.provider_trading_name ?? "-",
          checklist_name: item?.checklist_name ?? "-",
          client_trading_name: item?.client_trading_name ?? "-",
          document_display_name,
          doc_status: doc?.approval_status ?? "-",
          reviewed_date: doc?.reviewed_date ? moment(doc.reviewed_date).format("DD/MM/YYYY") : "-",
          doc_expiry_date: doc?.doc_expiry_date ? moment(doc.doc_expiry_date).format("DD/MM/YYYY") : "-",
        });
      });
    });
    return out;
  };

  const getExportCellValue = (item, key) => {
    if (key === "provider_org_id") {
      return item?.provider_org_id ?? item?.provider_id ?? "-";
    }

    if (key === "provider_abn_nzbn") {
      return item?.provider_abn_nzbn ?? item?.provider_abn_nzbn ?? item?.abn ?? "-";
    }

    if (key === "status" || key === "provider_status") {
      let st = item?.[key];
      if (st === "Assigned") return "Registered";
      if (st === "Registered") return "Self-Registered";
      if (st === "No-clients") return "Self-Registered";
      if (st === "Closed" || st === "Inactive") return "Deactivated";
      return st || "-";
    }

    return item?.[key] ?? "-";
  };

  const handleExport = async (format) => {
    setSuccessText(format);
    try {
      // Wait for data from GetPDFAllData
      const allReportData = await GetPDFAllData();

      if (!allReportData) {
        setCheckPdfLoad(false);
        console.error("Failed to fetch report data.");
        return;
      }
      setCheckPdfLoad(false);
      let rows = allReportData?.DocsReport || [];

      // If any rows are selected, export selected rows only.
      if (selectedRowKeys && selectedRowKeys.size > 0) {
        rows = rows.filter((r) => selectedRowKeys.has(buildRowKey(r)));
      }

      // Apply status filter on client side to ensure it's respected (document status)
      if (getAllinvitedData?.status && getAllinvitedData?.status !== "") {
        rows = rows.filter((it) => {
          const itemStatus = it?.status || "";
          return itemStatus.toLowerCase() === getAllinvitedData.status.toLowerCase();
        });
      }

      // Note: provider_status, site_ids, and other filters are handled by backend
      // The backend returns correctly filtered data based on all applied filters

      if (getAllinvitedData?.never_uploaded) {
        rows = rows.filter((it) => Number(it?.total_checklist_docs || 0) === 0);
      }

      const hasMeaningfulValue = (v) => {
        if (v === null || v === undefined) return false;
        const s = String(v).trim();
        return s !== "" && s !== "-";
      };

      const formatContactLabel = (contact) => {
        const first = (contact?.first_name || "").toString().trim();
        const last = (contact?.last_name || "").toString().trim();
        const email = (contact?.email || "").toString().trim();

        const name = [first, last].filter(Boolean).join(" ").trim();
        const label = name || "-";
        return { label, email: email || "-" };
      };

      // Client contact details (provider's client-specific contact) are populated directly by backend.
      rows = rows.map((r) => ({
        ...r,
        client_contact: hasMeaningfulValue(r?.client_contact) ? r.client_contact : "-",
        client_contact_email: hasMeaningfulValue(r?.client_contact_email)
          ? r.client_contact_email
          : "-",
      }));

      const getProviderDocsForRow = async (row) => {
        const orgId = row?.provider_org_id ?? row?.provider_id;
        const orgKey = orgId !== null && orgId !== undefined ? String(orgId) : "";
        if (!orgKey) return [];

        // FIX: Use context-based key instead of just provider ID to prevent caching collision
        const contextKey = buildRowKey(row); // Use the same key as buildRowKey: provider|client|checklist

        if (Array.isArray(providerDocsByOrgId?.[contextKey])) {
          return providerDocsByOrgId[contextKey];
        }

        const docs = await fetchAllProviderDocs(orgKey);
        setProviderDocsByOrgId((prev) => ({ ...prev, [contextKey]: docs }));
        return docs;
      };

      const workerDocsCache = new Map();
      const getWorkerDocsForRow = async (row) => {
        const providerId = row?.provider_org_id ?? row?.provider_id;
        const clientId = row?.client_org_id;
        if (!providerId || !clientId) return [];
        const key = `${providerId}|${clientId}|workers`;
        if (workerDocsCache.has(key)) return workerDocsCache.get(key);
        const docs = await fetchWorkerDocsForProviderClient(String(providerId), String(clientId));
        workerDocsCache.set(key, docs);
        return docs;

      };

      // Docs export should use report docs only (they have is_waived flag properly set)
      const enrichChecklistDocsForExport = async (row) => {
        const reportDocs = Array.isArray(row?.documents) ? row.documents : [];
        const docsRaw = reportDocs.filter((d) => d?.provider_doc_appr_id || d?.document_id);
        if (!Array.isArray(docsRaw) || docsRaw.length === 0) return [];

        const reportByDocumentId = new Map(
          reportDocs
            .filter((d) => d?.document_id !== null && d?.document_id !== undefined)
            .map((d) => [String(d.document_id), d])
        );

        const seen = new Set();
        const deduped = docsRaw.filter((d) => {
          // Filter out waived documents
          if (d?.is_waived) return false;

          // Prioritize org_document_id as it represents the master organizational record.
          // Fallback to document_id if org_document_id is missing.
          const id = d?.org_document_id ?? d?.document_id ?? null;
          const key =
            id !== null && id !== undefined && id !== ""
              ? String(id)
              : `${(d?.doc_type_name || "").toString().trim().toLowerCase()}|${(d?.doc_name || d?.other_doc_name || "").toString().trim().toLowerCase()}|${(d?.expiry_date || "").toString().trim()}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });

        return deduped.map((d) => {
          const key =
            d?.document_id !== null && d?.document_id !== undefined
              ? String(d.document_id)
              : "";
          const reportDoc = key ? reportByDocumentId.get(key) : null;
          return {
            ...d,
            approval_status: reportDoc?.approval_status ?? d?.approval_status ?? "pending",
            reviewed_date: reportDoc?.reviewed_date ?? d?.reviewed_date ?? null,
            doc_expiry_date: reportDoc?.doc_expiry_date ?? d?.doc_expiry_date ?? null,
          };
        });
      };

      if (format === "csv") {
        setCurrentCsvHeaders(csvHeaders);
        const csvRows = rows.map((item) => {
          return csvHeaders.reduce((newItem, header) => {
            let value = getExportCellValue(item, header.key);
            if (
              (header.key.toLowerCase().includes("creation_date") && value) ||
              header.key.toLowerCase().includes("approval_date")
            ) {
              value = moment(value).format("DD/MM/YYYY");
            }
            if (header.key === "completion_date" && value && value !== "-") {
              value = moment(value).format("DD/MM/YYYY");
            }
            newItem[header.key] = value ?? "-";
            return newItem;
          }, {});
        });

        // Add total count row at the end
        const totalRow = {};
        csvHeaders.forEach((header) => {
          if (header.key === "provider_trading_name") {
            totalRow[header.key] = `Total Providers: ${rows.length}`;
          } else {
            totalRow[header.key] = "";
          }
        });
        csvRows.push(totalRow);

        setProcessedCsvData(csvRows);
        return;
      } else if (format === "excel") {
        const headerRow = csvHeaders.map((header) => header.label);
        const dataRows = rows.map((item) =>
          csvHeaders.map((header) => {
            let value = getExportCellValue(item, header.key);
            if (header.key === "completion_date" && value && value !== "-") {
              value = moment(value).format("DD/MM/YYYY");
            }
            return value === undefined || value === null ? "-" : value;
          })
        );

        // Combine header and data rows.
        const exportData = [headerRow, ...dataRows];

        // Convert the AOA to a worksheet.
        const ws = XLSX.utils.aoa_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        downloadBlob(blob, "provider_summary_report.xlsx");
      } else if (format === "pdf") {
        const doc = new jsPDF("l"); // Set to landscape mode
        const today = moment().format("DD/MM/YYYY");

        // Set font and add date (top left)
        doc.setFontSize(12);
        doc.text(today, 14, 15);

        // Add title in center
        const title = "Provider Compliance Checklist List";
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(title, titleX, 15);

        // Convert PNG image to Base64
        const logoUrl = logoPDF;
        let logoData;
        try {
          logoData = await getBase64ImageFromUrl(logoUrl);
        } catch (error) {
          console.error("Error converting image to Base64", error);
        }

        // Add logo image at top right if available
        if (logoData) {
          const maxWidth = 45;
          const maxHeight = 15;
          const marginRight = 15;

          const imgProps = doc.getImageProperties(logoData);
          const ratio = imgProps.width / imgProps.height;

          let finalWidth = maxWidth;
          let finalHeight = finalWidth / ratio;

          if (finalHeight > maxHeight) {
            finalHeight = maxHeight;
            finalWidth = finalHeight * ratio;
          }

          doc.addImage(
            logoData,
            "PNG",
            pageWidth - finalWidth - marginRight,
            8,
            finalWidth,
            finalHeight
          );
        }

        // Prepare table headers and rows
        const tableColumn = [
          "Provider ID",
          "Provider Name",
          "ABN",
          "Checklist",
          "Client name",
          "Client Contact",
          "Client Contact Email",
          "Documents no.",
          "Completion rate",
          "Completion date",
        ];
        const tableRows = rows.map((row, index) => {
          return [
            row?.provider_org_id ?? row?.provider_id ?? "-",
            row.provider_trading_name,
            row.provider_abn_nzbn ?? "-",
            row.checklist_name,
            row.client_trading_name,
            row.client_contact ?? "-",
            row.client_contact_email ?? "-",
            row.total_checklist_docs,
            row.completion_rate,
            row.completion_date
              ? moment(row.completion_date).format("DD/MM/YYYY")
              : "-",
          ];
        });

        // Add table starting below the header
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 25,
          rowPageBreak: "avoid",
          styles: { fontSize: 10 }, // Reduce font size for better fit
          headStyles: {
            fillColor: "#E5F3FE",
            textColor: "#464A53",
            overflow: "visible",
          },
          bodyStyles: {
            textColor: "#000000",
            overflow: "linebreak",
          },
          columnStyles: {
            0: { cellWidth: "auto" },
            1: { cellWidth: "auto" },
            2: { cellWidth: "auto" },
            3: { cellWidth: "auto" },
            4: { cellWidth: "auto" },
            5: { cellWidth: "auto" },
            6: { cellWidth: "auto" },
            7: { cellWidth: "auto" },
            8: { cellWidth: "auto" },
            9: { cellWidth: "auto" },
          },
        });

        // Add total count at the bottom
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(10);
        doc.setFont(undefined, "normal");
        doc.text(`Total Providers: ${rows.length}`, 14, pageHeight - 15);

        // Save the PDF
        doc.save("provider_summary_report.pdf");
      }
      //  else if (format === "csv_docs") {
      //    const docRows = buildDocumentRows(rows);
      //    setCurrentCsvHeaders(docCsvHeaders);
      //    setProcessedCsvData(docRows);
      //    return;
      //  } else if (format === "excel_docs") {
      //    const docRows = buildDocumentRows(rows);
      //    const headerRow = docCsvHeaders.map((h) => h.label);
      //    const dataRows = docRows.map((r) => docCsvHeaders.map((h) => r[h.key] ?? "-"));
      //    const exportData = [headerRow, ...dataRows];
      //    const ws = XLSX.utils.aoa_to_sheet(exportData);
      //    const wb = XLSX.utils.book_new();
      //    XLSX.utils.book_append_sheet(wb, ws, "Documents");
      //    XLSX.writeFile(wb, "documents.xlsx");
      //    return;
      //  } else if (format === "pdf_docs") {
      //    const doc = new jsPDF("l");
      //    const today = moment().format("DD/MM/YYYY");
      //    doc.setFontSize(12);
      //    doc.text(today, 14, 15);

      //    const title = "Provider Compliance Checklist Documents";
      //    doc.setFontSize(16);
      //    const pageWidth = doc.internal.pageSize.getWidth();
      //    const titleWidth = doc.getTextWidth(title);
      //    const titleX = (pageWidth - titleWidth) / 2;
      //    doc.text(title, titleX, 15);

      //    const docRows = buildDocumentRows(rows);
      //    const docTableHead = [
      //      "Provider",
      //      "Checklist",
      //      "Client name",
      //      "Document",
      //      "Doc status",
      //      "Approval date",
      //      "Expiry date",
      //    ];
      //    const docTableBody = docRows.map((r) => [
      //      r.provider_trading_name,
      //      r.checklist_name,
      //      r.client_trading_name,
      //      r.document_display_name,
      //      r.doc_status,
      //      r.reviewed_date,
      //      r.doc_expiry_date,
      //    ]);
      //    doc.autoTable({
      //      head: [docTableHead],
      //      body: docTableBody,
      //      startY: 25,
      //      styles: { fontSize: 10 },
      //    });
      //    doc.save("provider_compliance_checklist_documents.pdf");
      //    return;
      //  }
      else if (format === "csv_docs") {
        const safeRows = Array.isArray(rows) ? rows : [];
        const header = [
          "Provider ID",
          "Provider",
          "Checklist",
          "Client",
          "Client Contact",
          "Client Contact Email",
          "Category",
          "Document Name",
          "Document Type",
          "Issuing Authority",
          "Issue date",
          "Policy number",
          "Amount insured",
          "Expiry date",
          // "Status", // Hidden per request (Approved/Pending/etc)
        ];

        const normalizeDocStatus = (raw) => {
          const s = (raw || "").toString().trim().toLowerCase();
          if (s === "approved") return "Approved";
          if (s === "client_approval_req") return "Client_approved_req";
          if (s === "client_approved_action") return "Client_approved_action";
          if (s === "admin_reject") return "Admin_reject";
          if (s === "client_reject") return "Client_reject";
          if (s === "pending" || !s || s === "-") return "Pending";
          if (s === "awaiting_review") return "Awaiting review";
          if (s === "action_required") return "Action required";
          return raw || "Pending";
        };

        const aoa = [header];
        for (const item of safeRows) {
          const docs = await enrichChecklistDocsForExport(item);
          if (!docs.length) {
            aoa.push([
              item?.provider_org_id ?? "-",
              item?.provider_trading_name ?? "-",
              item?.checklist_name ?? "-",
              item?.client_trading_name ?? "-",
              item?.client_contact ?? "-",
              item?.client_contact_email ?? "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              // "-", // Status (hidden)
            ]);
            continue;
          }

          docs.forEach((doc) => {
            const name = getDocNameForExport(doc);
            const category = normalizeDocCategoryLabel(doc?.doc_category);
            const docTypeName = doc?.doc_type_name || "-";
            const issuingAuthority = getIssuingAuthorityForExport(doc);
            const issue_date = getIssueDateForExport(doc)
              ? moment(getIssueDateForExport(doc)).format("DD/MM/YYYY")
              : "-";
            const expiry_date = getDocExpiryForExport(doc)
              ? moment(getDocExpiryForExport(doc)).format("DD/MM/YYYY")
              : "-";

            const policyNo = category === "Insurances" ? (doc?.policy_no || "-") : "-";
            const amountInsured =
              category === "Insurances" ? formatAmountInsured(doc?.amount_insured) : "-";

            aoa.push([
              item?.provider_org_id ?? "-",
              item?.provider_trading_name ?? "-",
              item?.checklist_name ?? "-",
              item?.client_trading_name ?? "-",
              item?.client_contact ?? "-",
              item?.client_contact_email ?? "-",
              category,
              name,
              docTypeName,
              issuingAuthority,
              issue_date,
              policyNo,
              amountInsured,
              expiry_date,
              // normalizeDocStatus(doc?.approval_status), // Status (hidden)
            ]);
          });

          const workerDocs = await getWorkerDocsForRow(item);
          if (workerDocs.length) {
            aoa.push(["Workers", "", "", "", "", "", "", "", "", "", "", "", "", "" /* Status */]);
            aoa.push([
              "ID",
              "Name",
              "Occupation",
              "Certification Name",
              "Document Type",
              "Issuing Authority",
              "Valid From",
              "Valid To",
              "",
              "",
              "",
              "",
              "",
              "",
              // "", // Status (hidden)
            ]);
            workerDocs.forEach((wd) => {
              aoa.push([
                wd?.display_worker_id ?? (wd?.worker_id ? `E-${wd.worker_id}` : "-"),
                wd?.worker_name ?? "-",
                wd?.occupation ?? "-",
                wd?.certification_name ?? "-",
                wd?.doc_type_name ?? "-",
                wd?.issuing_authority ?? "-",
                wd?.valid_from ? moment(wd.valid_from).format("DD/MM/YYYY") : "-",
                wd?.valid_to ? moment(wd.valid_to).format("DD/MM/YYYY") : "-",
                "",
                "",
                "",
                "",
                "",
                "",
                // "", // Status (hidden)
              ]);
            });
          }
        }

        // Add total count row at the end (Provider column)
        aoa.push(new Array(header.length).fill(""));
        const totalRow = new Array(header.length).fill("");
        totalRow[1] = `Total Providers: ${safeRows.length}`;
        aoa.push(totalRow);

        const toCsv = (matrix) =>
          matrix
            .map((row) =>
              row.map((val) => `"${String(val ?? "-").replaceAll('"', '""')}"`).join(",")
            )
            .join("\n");
        const csv = toCsv(aoa);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "provider_summary_report_documents.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return;
      }
      else if (format === "excel_docs") {
        const normalizeDocStatus = (raw) => {
          const s = (raw || "").toString().trim().toLowerCase();
          if (s === "approved") return "Approved";
          if (s === "client_approval_req") return "Client_approved_req";
          if (s === "client_approved_action") return "Client_approved_action";
          if (s === "admin_reject") return "Admin_reject";
          if (s === "client_reject") return "Client_reject";
          if (s === "pending" || !s || s === "-") return "Pending";
          if (s === "awaiting_review") return "Awaiting review";
          if (s === "action_required") return "Action required";
          return raw || "Pending";
        };

        // Use a consistent set of columns for all categories to avoid Excel column shifting.
        const headerRow = [
          "Provider ID",
          "Provider",
          "Checklist",
          "Client",
          "Client Contact",
          "Client Contact Email",
          "Category",
          "Document Name",
          "Document Type",
          "Issuing Authority",
          "Issue date",
          "Policy number",
          "Amount insured",
          "Expiry date",
          // "Status", // Hidden per request (Approved/Pending/etc)
        ];
        const aoa = [headerRow];
        const safeRows = Array.isArray(rows) ? rows : [];
        const expiredCells = []; // Store expired cell positions to apply styling later

        for (const item of safeRows) {
          const docs = await enrichChecklistDocsForExport(item);

          // Provider row header (Option A)
          aoa.push([
            item?.provider_org_id ?? "-",
            item?.provider_trading_name ?? "-",
            item?.checklist_name ?? "-",
            item?.client_trading_name ?? "-",
            item?.client_contact ?? "-",
            item?.client_contact_email ?? "-",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            // "", // Status (hidden)
          ]);

          const groups = groupDocsForExport(docs);
          if (!groups.length) {
            aoa.push(new Array(headerRow.length).fill(""));
            continue;
          }

          groups.forEach((g) => {
            // Category header row
            aoa.push(["", "", "", "", "", "", String(g.label || "Others"), "", "", "", "", "", "", ""]);

            // Sub-header row: keep same width as headerRow; show relevant labels per category.
            const sub = ["", "", "", "", "", "", "", "Document Name", "Document Type", "Issuing Authority", "Issue date", "Policy number", "Amount insured", "Expiry date"];
            if (g.label === "Insurances") {
              sub[8] = "Insurances Type";
            }
            if (g.label === "WHS") {
              sub[11] = "";
              sub[12] = "";
            }
            if (g.label === "Info") {
              sub[11] = "";
              sub[12] = "";
            }
            aoa.push(sub);

            (g.rows || []).forEach((doc) => {
              const name = getDocNameForExport(doc);
              const docTypeName = doc?.doc_type_name || "-";
              const expiry_date = getDocExpiryForExport(doc)
                ? moment(getDocExpiryForExport(doc)).format("DD/MM/YYYY")
                : "-";

              const issuingAuthority = getIssuingAuthorityForExport(doc);
              const issue_date = getIssueDateForExport(doc)
                ? moment(getIssueDateForExport(doc)).format("DD/MM/YYYY")
                : "-";
              const policyNo = doc?.policy_no || "-";
              const amountInsured = formatAmountInsured(doc?.amount_insured);

              // Check if document is expired
              const exp = getDocExpiryForExport(doc);
              const isExpired = exp && moment(exp).isValid() && moment(exp).isBefore(moment(), "day");

              const baseRow = [
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                name,
                docTypeName,
                issuingAuthority,
                issue_date,
                policyNo,
                amountInsured,
                expiry_date,
                // normalizeDocStatus(doc?.approval_status), // Status (hidden)
              ];

              if (g.label === "Licenses") {
                baseRow[11] = "-";
                baseRow[12] = "-";
              } else if (g.label === "Insurances") {
                // Keep policy number / amount insured for Insurances.
              } else if (g.label === "WHS") {
                baseRow[11] = "";
                baseRow[12] = "";
              } else if (g.label === "Company Registration") {
                baseRow[11] = "";
                baseRow[12] = "";
              } else if (g.label === "Info") {
                baseRow[11] = "";
                baseRow[12] = "";
              } else {
                baseRow[11] = "";
                baseRow[12] = "";
              }

              aoa.push(baseRow);

              // Store expired cell positions for styling after worksheet creation
              if (isExpired) {
                const rowIndex = aoa.length - 1;
                // Style all columns in the expired row
                for (let c = 7; c <= headerRow.length - 1; c++) {
                  expiredCells.push({ r: rowIndex, c: c });
                }
              }
            });
          });

          const workerDocs = await getWorkerDocsForRow(item);
          if (workerDocs.length) {
            aoa.push(["", "", "", "", "", "", "Workers", "", "", "", "", "", "", ""]);
            aoa.push([
              "",
              "",
              "",
              "",
              "",
              "",
              "ID",
              "Name",
              "Occupation",
              "Certification Name",
              "Document Type",
              "Issuing Authority",
              "Valid From",
              "Valid To",
              // "", // Status (hidden)
            ]);

            workerDocs.forEach((wd) => {
              const validTo = wd?.valid_to ? moment(wd.valid_to).format("DD/MM/YYYY") : "-";
              const validFrom = wd?.valid_from ? moment(wd.valid_from).format("DD/MM/YYYY") : "-";
              const row = [
                "",
                "",
                "",
                "",
                "",
                "",
                wd?.display_worker_id ?? (wd?.worker_id ? `E-${wd.worker_id}` : "-"),
                wd?.worker_name ?? "-",
                wd?.occupation ?? "-",
                wd?.certification_name ?? "-",
                wd?.doc_type_name ?? "-",
                wd?.issuing_authority ?? "-",
                validFrom,
                validTo,
                // "", // Status (hidden)
              ];
              aoa.push(row);

              const isExpired =
                wd?.valid_to &&
                moment(wd.valid_to).isValid() &&
                moment(wd.valid_to).isBefore(moment(), "day");
              if (isExpired) {
                const rowIndex = aoa.length - 1;
                for (let col = 6; col <= headerRow.length - 1; col += 1) {
                  expiredCells.push({ r: rowIndex, c: col });
                }
              }
            });
          }
        }

        // Add total count row at the end
        aoa.push(new Array(headerRow.length).fill(""));
        const totalRow = new Array(headerRow.length).fill("");
        totalRow[0] = `Total Providers: ${safeRows.length}`;
        aoa.push(totalRow);

        const ws = XLSX.utils.aoa_to_sheet(aoa);
        // Step 1: Column widths (wch ~= number of characters).
        ws["!cols"] = [
          { wch: 14 }, // Provider ID
          { wch: 28 }, // Provider
          { wch: 18 }, // Checklist
          { wch: 28 }, // Client
          { wch: 20 }, // Client Contact
          { wch: 30 }, // Client Contact Email
          { wch: 16 }, // Category
          { wch: 42 }, // Document Name
          { wch: 28 }, // Document Type / Insurances Type
          { wch: 30 }, // Issuing Authority
          { wch: 14 }, // Issue date
          { wch: 20 }, // Policy number
          { wch: 18 }, // Amount insured
          { wch: 14 }, // Expiry date
          // { wch: 14 }, // Status (hidden)
        ];

        // Step 2: Best-effort wrap text (depends on XLSX writer support).
        const ref = ws["!ref"];
        if (ref) {
          const range = XLSX.utils.decode_range(ref);
          for (let r = range.s.r; r <= range.e.r; r += 1) {
            for (let c = range.s.c; c <= range.e.c; c += 1) {
              const addr = XLSX.utils.encode_cell({ r, c });
              const cell = ws[addr];
              if (!cell) continue;
              cell.s = cell.s || {};
              cell.s.alignment = {
                ...(cell.s.alignment || {}),
                wrapText: true,
                vertical: "top",
              };
            }
          }
        }

        // Step 3: Apply red font styling to expired document cells
        expiredCells.forEach(({ r, c }) => {
          const cellRef = XLSX.utils.encode_cell({ r, c });
          if (!ws[cellRef]) return;

          // Preserve existing styles
          const existingStyle = ws[cellRef].s || {};
          const existingFont = existingStyle.font || {};

          ws[cellRef].s = {
            ...existingStyle,
            font: {
              ...existingFont,
              color: { rgb: "FFDC2626" }, // Red color with FF alpha channel
              bold: true,
            },
          };
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Documents");

        const wbout = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([wbout], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        downloadBlob(blob, "provider_summary_report_documents.xlsx");
        return;
      }
      else if (format === "pdf_docs") {
        const doc = new jsPDF("l");
        const today = moment().format("DD/MM/YYYY");
        doc.setFontSize(12);
        doc.text(today, 14, 15);

        const title = "Provider Summary Report Documents";
        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;
        doc.text(title, titleX, 15);

        const logoUrl = logoPDF;
        let logoData;
        try {
          logoData = await getBase64ImageFromUrl(logoUrl);
        } catch (error) {
          console.error("Error converting image to Base64", error);
        }

        if (logoData) {
          const maxWidth = 45;
          const maxHeight = 15;
          const marginRight = 15;

          const imgProps = doc.getImageProperties(logoData);
          const ratio = imgProps.width / imgProps.height;

          let finalWidth = maxWidth;
          let finalHeight = finalWidth / ratio;

          if (finalHeight > maxHeight) {
            finalHeight = maxHeight;
            finalWidth = finalHeight * ratio;
          }

          doc.addImage(
            logoData,
            "PNG",
            pageWidth - finalWidth - marginRight,
            8,
            finalWidth,
            finalHeight
          );
        }

        // Start rendering groups
        let startY = 25;
        const safeRows = Array.isArray(rows) ? rows : [];

        const normalizeDocStatus = (raw) => {
          const s = (raw || "").toString().trim().toLowerCase();
          if (s === "approved") return "Approved";
          if (s === "client_approval_req") return "Client_approved_req";
          if (s === "client_approved_action") return "Client_approved_action";
          if (s === "admin_reject") return "Admin_reject";
          if (s === "client_reject") return "Client_reject";
          if (s === "pending" || !s || s === "-") return "Pending";
          if (s === "awaiting_review") return "Awaiting review";
          if (s === "action_required") return "Action required";
          return raw || "Pending";
        };

        for (let idx = 0; idx < safeRows.length; idx += 1) {
          const item = safeRows[idx];
          // Provider header (bold) - wrap columns so they don't overlap
          doc.setFontSize(11);
          doc.setFont(undefined, "bold");

          const col1X = 14;
          const col2X = 110;
          const col3X = 210;
          const colWidth = 90;
          const lineHeight = 5;

          const providerLines = doc.splitTextToSize(
            `Provider: ${item?.provider_trading_name ?? "-"}`,
            colWidth
          );
          const providerIdLines = doc.splitTextToSize(
            `Provider ID: ${item?.provider_org_id ?? "-"}`,
            colWidth
          );
          const checklistLines = doc.splitTextToSize(
            `Checklist: ${item?.checklist_name ?? "-"}`,
            colWidth
          );

          const clientLines = doc.splitTextToSize(
            `Client: ${item?.client_trading_name ?? "-"}`,
            colWidth
          );
          const contactLines = doc.splitTextToSize(
            `Client Contact: ${item?.client_contact ?? "-"}`,
            colWidth
          );
          const emailLines = doc.splitTextToSize(
            `Client Contact Email: ${item?.client_contact_email ?? "-"}`,
            colWidth
          );

          doc.text(providerLines, col1X, startY);
          doc.text(providerIdLines, col2X, startY);
          doc.text(checklistLines, col3X, startY);

          const r1Lines = Math.max(
            providerLines.length,
            providerIdLines.length,
            checklistLines.length
          );
          startY += r1Lines * lineHeight + 2;

          doc.text(clientLines, col1X, startY);
          doc.text(contactLines, col2X, startY);
          doc.text(emailLines, col3X, startY);

          const r2Lines = Math.max(
            clientLines.length,
            contactLines.length,
            emailLines.length
          );
          startY += r2Lines * lineHeight + 6;

          doc.setFont(undefined, "normal");

          const docs = await enrichChecklistDocsForExport(item);
          const groups = groupDocsForExport(docs);

          if (!groups.length) {
            doc.autoTable({
              head: [["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date" /*, "Status"*/]],
              body: [["-", "-", "-", "-", "-" /*, "-"*/]],
              startY,
              styles: { fontSize: 9, overflow: "linebreak", cellPadding: 2, valign: "top" },
              headStyles: { fillColor: "#E5F3FE", textColor: "#464A53", overflow: "linebreak" },
              rowPageBreak: "avoid",
              columnStyles: {
                0: { cellWidth: 80 },
                1: { cellWidth: 60 },
                2: { cellWidth: 45 },
                3: { cellWidth: 35 },
                4: { cellWidth: 35 },
                // 5: { cellWidth: 30 }, // Status (hidden)
              },
              margin: { left: 14 },
              tableWidth: 260,
            });
            startY = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 8 : startY + 20;
          } else {
            groups.forEach((g) => {
              const pageHeight = doc.internal.pageSize.getHeight();
              if (startY > pageHeight - 30) {
                doc.addPage("l");
                startY = 20;
              }

              doc.setFontSize(10);
              doc.setFont(undefined, "bold");
              doc.text(String(g.label || "Others"), 14, startY);
              doc.setFont(undefined, "normal");
              startY += 4;

              let head;
              let body;

              if (g.label === "Licenses") {
                head = [["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date" /*, "Status"*/]];
                body = (g.rows || []).map((d) => [
                  d?.doc_name || (d?.is_other_doc ? (d?.other_doc_name || "-") : "-"),
                  d?.doc_type_name || "-",
                  getIssuingAuthorityForExport(d),
                  getIssueDateForExport(d) ? moment(getIssueDateForExport(d)).format("DD/MM/YYYY") : "-",
                  getDocExpiryForExport(d) ? moment(getDocExpiryForExport(d)).format("DD/MM/YYYY") : "-",
                  // normalizeDocStatus(d?.approval_status), // Status (hidden)
                ]);
              } else if (g.label === "Insurances") {
                head = [["Document Name", "Insurances Type", "Issuing Authority", "Issue date", "Policy number", "Amount insured", "Expiry date" /*, "Status"*/]];
                body = (g.rows || []).map((d) => [
                  d?.doc_name || (d?.is_other_doc ? (d?.other_doc_name || "-") : "-"),
                  d?.doc_type_name || "-",
                  getIssuingAuthorityForExport(d),
                  getIssueDateForExport(d) ? moment(getIssueDateForExport(d)).format("DD/MM/YYYY") : "-",
                  d?.policy_no || "-",
                  formatAmountInsured(d?.amount_insured),
                  getDocExpiryForExport(d) ? moment(getDocExpiryForExport(d)).format("DD/MM/YYYY") : "-",
                  // normalizeDocStatus(d?.approval_status), // Status (hidden)
                ]);
              } else if (g.label === "WHS") {
                head = [["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date" /*, "Status"*/]];
                body = (g.rows || []).map((d) => [
                  d?.doc_name || (d?.is_other_doc ? (d?.other_doc_name || "-") : "-"),
                  d?.doc_type_name || "-",
                  getIssuingAuthorityForExport(d),
                  getIssueDateForExport(d) ? moment(getIssueDateForExport(d)).format("DD/MM/YYYY") : "-",
                  getDocExpiryForExport(d) ? moment(getDocExpiryForExport(d)).format("DD/MM/YYYY") : "-",
                  // normalizeDocStatus(d?.approval_status), // Status (hidden)
                ]);
              } else if (g.label === "Company Registration") {
                head = [["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date" /*, "Status"*/]];
                body = (g.rows || []).map((d) => [
                  d?.doc_name || (d?.is_other_doc ? (d?.other_doc_name || "-") : "-"),
                  d?.doc_type_name || "-",
                  d?.issuing_authority || "-",
                  getIssueDateForExport(d) ? moment(getIssueDateForExport(d)).format("DD/MM/YYYY") : "-",
                  getDocExpiryForExport(d) ? moment(getDocExpiryForExport(d)).format("DD/MM/YYYY") : "-",
                  // normalizeDocStatus(d?.approval_status), // Status (hidden)
                ]);
              } else {
                head = [["Document Name", "Document Type", "Issuing Authority", "Issue date", "Expiry date" /*, "Status"*/]];
                body = (g.rows || []).map((d) => [
                  d?.doc_name || (d?.is_other_doc ? (d?.other_doc_name || "-") : "-"),
                  d?.doc_type_name || "-",
                  getIssuingAuthorityForExport(d),
                  getIssueDateForExport(d) ? moment(getIssueDateForExport(d)).format("DD/MM/YYYY") : "-",
                  getDocExpiryForExport(d) ? moment(getDocExpiryForExport(d)).format("DD/MM/YYYY") : "-",
                  // normalizeDocStatus(d?.approval_status), // Status (hidden)
                ]);
              }

              // Store expired document info for styling
              const expiredRows = new Set();
              (g.rows || []).forEach((d, idx) => {
                const exp = getDocExpiryForExport(d);
                if (exp && moment(exp).isValid() && moment(exp).isBefore(moment(), "day")) {
                  expiredRows.add(idx);
                }
              });

              doc.autoTable({
                head,
                body: body.length > 0 ? body : [new Array((head?.[0] || []).length || 1).fill("-")],
                startY,
                styles: { fontSize: 9, overflow: "linebreak", cellPadding: 2, valign: "top" },
                headStyles: { fillColor: "#E5F3FE", textColor: "#464A53", overflow: "linebreak" },
                rowPageBreak: "avoid",
                margin: { left: 14 },
                willDrawCell: function (data) {
                  // Apply red text color to all cells in expired document rows
                  if (data.section === 'body' && expiredRows.has(data.row.index)) {
                    doc.setTextColor(220, 38, 38); // Red color (#DC2626)
                    doc.setFont(undefined, "bold");
                  }
                },
                didDrawCell: function (data) {
                  // Reset text color after drawing
                  if (data.section === 'body') {
                    doc.setTextColor(0, 0, 0); // Reset to black
                    doc.setFont(undefined, "normal");
                  }
                },
              });
              startY = (doc.lastAutoTable && doc.lastAutoTable.finalY)
                ? doc.lastAutoTable.finalY + 8
                : startY + 20;
            });
          }

          const workerDocs = await getWorkerDocsForRow(item);
          if (workerDocs.length) {
            const pageHeight = doc.internal.pageSize.getHeight();
            if (startY > pageHeight - 30) {
              doc.addPage("l");
              startY = 20;
            }

            doc.setFontSize(10);
            doc.setFont(undefined, "bold");
            doc.text("Workers", 14, startY);
            doc.setFont(undefined, "normal");
            startY += 4;

            const workerHead = [[
              "ID",
              "Name",
              "Occupation",
              "Certification Name",
              "Document Type",
              "Issuing Authority",
              "Valid From",
              "Valid To",
            ]];

            const workerGroupIndexes = [];
            const workerBody = [];
            let currentWorkerKey = null;
            let currentWorkerGroup = -1;

            workerDocs.forEach((wd) => {
              const workerKey =
                wd?.worker_id ??
                wd?.employee_id_v2 ??
                `${wd?.display_worker_id || ""}|${wd?.worker_name || ""}`;
              const isNewWorker = String(workerKey) !== String(currentWorkerKey);

              if (isNewWorker) {
                currentWorkerKey = workerKey;
                currentWorkerGroup += 1;
              }

              workerGroupIndexes.push(currentWorkerGroup);
              workerBody.push([
                isNewWorker ? (wd?.display_worker_id ?? (wd?.worker_id ? `E-${wd.worker_id}` : "-")) : "",
                isNewWorker ? (wd?.worker_name ?? "-") : "",
                isNewWorker ? (wd?.occupation ?? "-") : "",
                wd?.certification_name ?? "-",
                wd?.doc_type_name ?? "-",
                wd?.issuing_authority ?? "-",
                wd?.valid_from ? moment(wd.valid_from).format("DD/MM/YYYY") : "-",
                wd?.valid_to ? moment(wd.valid_to).format("DD/MM/YYYY") : "-",
              ]);
            });

            const expiredWorkerRows = new Set();
            workerDocs.forEach((wd, idx2) => {
              if (
                wd?.valid_to &&
                moment(wd.valid_to).isValid() &&
                moment(wd.valid_to).isBefore(moment(), "day")
              ) {
                expiredWorkerRows.add(idx2);
              }
            });

            doc.autoTable({
              head: workerHead,
              body: workerBody.length > 0 ? workerBody : [["-", "-", "-", "-", "-", "-", "-", "-"]],
              startY,
              styles: { fontSize: 9, overflow: "linebreak", cellPadding: 2, valign: "top" },
              headStyles: { fillColor: "#E5F3FE", textColor: "#464A53", overflow: "linebreak" },
              rowPageBreak: "avoid",
              margin: { left: 14 },
              didParseCell: function (data) {
                if (data.section === "body") {
                  const groupIndex = workerGroupIndexes[data.row.index] ?? data.row.index;
                  data.cell.styles.fillColor = groupIndex % 2 === 0 ? [245, 245, 245] : [255, 255, 255];
                }
              },
              willDrawCell: function (data) {
                if (data.section === "body" && expiredWorkerRows.has(data.row.index)) {
                  doc.setTextColor(220, 38, 38);
                  doc.setFont(undefined, "bold");
                }
              },
              didDrawCell: function (data) {
                if (data.section === "body") {
                  doc.setTextColor(0, 0, 0);
                  doc.setFont(undefined, "normal");
                }
              },
            });
            startY = (doc.lastAutoTable && doc.lastAutoTable.finalY)
              ? doc.lastAutoTable.finalY + 8
              : startY + 20;
          }

          // Add page if nearing bottom
          if (startY > doc.internal.pageSize.getHeight() - 20 && idx < safeRows.length - 1) {
            doc.addPage("l");
            startY = 20;
          }
        }

        // Add total count at the bottom (ensure there's space on the current page)
        const pageHeight = doc.internal.pageSize.getHeight();
        const footerY = pageHeight - 15;
        const lastY =
          doc.lastAutoTable && typeof doc.lastAutoTable.finalY === "number"
            ? doc.lastAutoTable.finalY
            : 0;
        if (lastY > footerY - 10) {
          doc.addPage("l");
        }
        doc.setFontSize(10);
        doc.setFont(undefined, "normal");
        doc.text(`Total Providers: ${safeRows.length}`, 14, doc.internal.pageSize.getHeight() - 15);

        doc.save("provider_summary_report_documents.pdf");
        return;
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      notify.show(
        "Export failed. Please try again.",
        "error",
        3000
      );
    }
  };

  const closeDownloadSuccessPdf = () => {
    setPdfDownloadSuccessDialog(false);
    setTimeout(() => {
      setCheckPdfLoad(true);
    }, 1000);
  };

  useEffect(() => {
    if (processedCsvData.length > 0) {
      csvLinkRef.current.link.click();
    }
    return () => {
      setCustReportName(""); // Reset state on cleanup (unmount or dependency change)
    };
  }, [processedCsvData]); // Runs when processedCsvData updates


  const inputChangeHandler = (e) => {

    setCustReportName(e)
    setCustErrMsg("")

    // Clear the error if there's any
    // setErrors(prevErrors => ({ ...prevErrors, removeUserMsgError: "" }));
  };

  const handleFavReports = (reportType, reportTitle, isFav) => {
    setSelectReport(!selectReport)
    const payload = {
      user_id: userId, // Dynamically passed userId
      report_type: reportType, // Dynamically passed reportType
      is_favourite: isFav,
      user_type: userType, // Dynamically passed userType
      report_dashboard: "provider",
      report_title: reportTitle
    }

    dispatch(ProviderFavouriteReportsOrNot(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          // Optionally update UI or give feedback to the user
          // For example, you can update a state variable to show the report is favorited
        } else {
          // Handle non-successful status codes here
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error('Error favoriting report:', error);
        // Optionally show a user-friendly message
      });
  }
  useEffect(() => {
    if (favReport) {
      setSelectReport(favReport.some((ele) => ele.report_type == "compliance-checklist"))
    }
  }, [favReport])


  useEffect(() => {
    if (cstRep) {

      setSaveCustomRep(cstRep.some((ele) => ele.report_type == "compliance-checklist"))
      if (cstRep.some((ele) => ele.report_type == "compliance-checklist")) {
        setCustSuccessMsg(true)
        const data = cstRep[0]?.apply_filters
        // SetgetAllinvitedData] = useState({
        //   status: "",
        //   page: 1,
        //   limit: 10,
        //   sort: "created_date",
        //   order: "desc",
        //   completion_date_range: "",
        // });

        SetgetAllinvitedData({
          client_org_ids: data?.client_org_ids ? JSON.parse(data.client_org_ids) : [],
          provider_org_ids: data?.provider_org_ids ? JSON.parse(data?.provider_org_ids) : [],
          checklist_ids: data?.checklist_ids ? JSON.parse(data?.checklist_ids) : [],
          page: data?.page,
          limit: data?.limit,
          sort: data?.sort,
          order: data?.order,
          status: data?.status,
          provider_status: data?.provider_status || "",
          never_uploaded: Boolean(data?.never_uploaded) || false,
          completion_date_range: data?.completion_date_range
        });

      }
    }
  }, [cstRep])
  const handleConfirm = () => {
    unSaveSetIsOpen(true);
  }
  const handleUpdateCustomRep = () => {
    setRemoveDialog(true);
  }
  const onDialogCloseRemove = () => {
    setRemoveDialog(false);

  };
  const onDialogCloseUnSave = () => {
    unSaveSetIsOpen(false);

  };
  const onCloseDetails = () => {
    setCustSuccessMsg(false)
    navigate(-1);
    setOpenSuccessDialog("")
  }
  const handleCustom = (reportType, reportTitle, isCustom, type) => {
    if (!saveCustomRep && !custReportName) {
      setCustErrMsg("Please enter custom report name")
      return
    }
    const basePayload = {
      is_custom: isCustom,
      user_id: userId,
      report_type: reportType,
      user_type: userType,
      report_dashboard: "provider",
      custom_report_name: cstRep?.[0]?.custom_report_name ? cstRep?.[0]?.custom_report_name : custReportName,
      report_title: reportTitle,
      apply_filters: {
        ...getAllinvitedData,
        status: (getAllinvitedData.status || "").replace(/\s+/g, "_"),
        provider_status: (getAllinvitedData.provider_status || "").toString().trim(),
        never_uploaded: Boolean(getAllinvitedData.never_uploaded) || false,
        client_org_ids: JSON.stringify(
          getAllinvitedData.client_org_ids?.map((item) => item?.organisation_id)
        ),
        provider_org_ids: JSON.stringify(
          getAllinvitedData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        checklist_ids: JSON.stringify(getAllinvitedData.checklist_ids),

      }
    };

    if (type == "update" || saveCustomRep) {
      basePayload.report_custom_id = cstRep?.[0]?.report_custom_id;
    }

    const payload = basePayload



    dispatch(ProviderCustomReports(payload))
      .then((res) => {
        if (res.status) {
          // Handle the success response here
          if (type == "createOrDelete") {
            setSaveCustomRep(!saveCustomRep)
            setCustReportName("")
            setOpenSuccessDialog(true)
            // navigate( {
            //   state: { favReport }
            // });
            //here i want to upload empty navigation data where i want to empty of cstRep data
            unSaveSetIsOpen(false);
          } else if (type == "update") {
            setSaveCustomRep(true)
            setRemoveDialog(false)
            setOpenSuccessDialog(true)
          }

        } else {
          // Handle non-successful status codes here
          console.error('Failed to favorite report:', res.message || 'Unknown error');
        }
      })
      .catch((error) => {
        // Handle the error (e.g., network error, server error, etc.)
        console.error('Error favoriting report:', error);
        // Optionally show a user-friendly message
      });



  }
  return (
    <React.Fragment>
      <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
        <Heading>Provider Summary Report</Heading>
        <div className="flex flex-wrap gap-4 mt-5">
          <button
            onClick={generateProviderChecklistOverview}
            disabled={isGenerating}
            className="bg-[#5786CC] text-white text-xs px-3 py-1 rounded-md transition ml-2 flex items-center justify-center min-w-[94px] disabled:opacity-60 disabled:cursor-not-allowed hover:bg-[#3f6ab4]"
          >
            {isGenerating ? <ThreeDotLoader /> : "Generate"}
          </button>
          {/* <BtnLight
            className="h-10 w-10 flex items-center justify-center gap-2 text-12">
            {selectReport ?
              (<svg
                onClick={() => handleFavReports("compliance-checklist", " Providers Checklist Overview", false)}
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15736_74961)">
                  <path
                    d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                    fill="#FDB022"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15736_74961">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.333984 0.800781)"
                    />
                  </clipPath>
                </defs>
              </svg>)
              :
              (
                <svg onClick={() => handleFavReports("compliance-checklist", " Providers Checklist Overview", true)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.40156 2.8778C9.59363 2.48869 9.68967 2.29413 9.82004 2.23197C9.93347 2.17789 10.0653 2.17789 10.1787 2.23197C10.3091 2.29413 10.4051 2.48869 10.5972 2.8778L12.4194 6.56944C12.4761 6.68432 12.5045 6.74176 12.5459 6.78635C12.5826 6.82584 12.6266 6.85783 12.6754 6.88056C12.7306 6.90623 12.794 6.91549 12.9208 6.93402L16.9968 7.5298C17.4261 7.59253 17.6407 7.6239 17.74 7.72874C17.8264 7.81995 17.8671 7.94529 17.8506 8.06985C17.8317 8.21302 17.6763 8.36436 17.3656 8.66702L14.4172 11.5387C14.3253 11.6282 14.2794 11.673 14.2497 11.7263C14.2235 11.7734 14.2066 11.8252 14.2001 11.8788C14.1928 11.9393 14.2036 12.0025 14.2253 12.129L14.921 16.1851C14.9944 16.6129 15.031 16.8269 14.9621 16.9538C14.9021 17.0642 14.7955 17.1417 14.6719 17.1646C14.5299 17.1909 14.3378 17.0899 13.9536 16.8879L10.3097 14.9716C10.1961 14.9119 10.1394 14.882 10.0796 14.8703C10.0266 14.8599 9.97213 14.8599 9.91918 14.8703C9.85937 14.882 9.8026 14.9119 9.68906 14.9716L6.04512 16.8879C5.66095 17.0899 5.46886 17.1909 5.32683 17.1646C5.20325 17.1417 5.09662 17.0642 5.03663 16.9538C4.96768 16.8269 5.00437 16.6129 5.07774 16.1851L5.77342 12.129C5.79511 12.0025 5.80595 11.9393 5.79862 11.8788C5.79212 11.8252 5.77528 11.7734 5.74902 11.7263C5.71937 11.673 5.67341 11.6282 5.5815 11.5387L2.63315 8.66702C2.3224 8.36436 2.16703 8.21302 2.14812 8.06985C2.13167 7.94529 2.17231 7.81995 2.25872 7.72874C2.35804 7.6239 2.57266 7.59253 3.00189 7.5298L7.07794 6.93402C7.2047 6.91549 7.26808 6.90623 7.32328 6.88056C7.37215 6.85783 7.41615 6.82584 7.45284 6.78635C7.49427 6.74176 7.52262 6.68432 7.57933 6.56944L9.40156 2.8778Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              )

            }

          </BtnLight> */}
          {/* <BtnLight onClick={handleConfirm} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
            {saveCustomRep ? "Remove custom report" : "Save as custom report"}
          </BtnLight>
          {saveCustomRep && (
            <BtnLight onClick={handleUpdateCustomRep} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
              {saveCustomRep && "Update custom report"}
            </BtnLight>
          )} */}

          <div className="export-dropdow">
            <Dropdown title="Export" className="dropdown-btn">
              {/* <Dropdown.Item
                eventKey="a"
                onClick={() => handleExport("csv")}
                className="text-gray-900 font font-medium"
              >
                CSV
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="b"
                onClick={() => handleExport("excel")}
                className="text-gray-900 font font-medium"
              >
                Excel
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="c"
                onClick={() => handleExport("pdf")}
                className="text-gray-900 font font-medium"
              >
                PDF
              </Dropdown.Item> */}
              <Dropdown.Item
                eventKey="d"
                onClick={() => handleExport("csv_docs")}
                className="text-gray-900 font font-medium"
              >
                CSV
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="e"
                onClick={() => handleExport("excel_docs")}
                className="text-gray-900 font font-medium"
              >
                Excel
              </Dropdown.Item>
              <Dropdown.Item
                eventKey="f"
                onClick={() => handleExport("pdf_docs")}
                className="text-gray-900 font font-medium"
              >
                PDF
              </Dropdown.Item>
            </Dropdown>
            {/* HIDDEN CSVLink - clicked programmatically for CSV export */}
            {processedCsvData?.length > 0 && (
              <CSVLink
                data={processedCsvData}
                headers={currentCsvHeaders}
                filename="provider_summary_report.csv"
                className="hidden"
                ref={csvLinkRef}
                target="_blank"
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-3 mb-4">
        {/* Row 1 */}
        <div className="flex gap-1 cstm-dropdown flex-wrap">
          <div>
            <ClientMultiSelectDropdown
              title="Client"
              updateFilter={updateFilter}
            />
          </div>
          <div>
            <ProviderMultiSelectDropdown
              title="Provider"
              updateFilter={updateFilter}
              client_org_ids={getAllinvitedData?.client_org_ids}
            />
          </div>
          <div>
            <CheckListMultiSelectDropdown
              title="Checklist"
              updateFilter={updateFilter}
              provider_org_ids={getAllinvitedData?.provider_org_ids}
              client_org_ids={getAllinvitedData?.client_org_ids}
            />
          </div>

          <div>
            <StatusMultiSelectDropdown
              statusData={[
                "approved",
                "awaiting review",
                "action required",
                { label: "Never uploaded", value: "never_uploaded" },
              ]}
              title={"Document Status"}
              updateFilter={updateFilter}
              enableNeverUploaded
              multiSelect
            />
          </div>
          <div>
            <StatusMultiSelectDropdown
              statusData={[
                "Compliant",
                "Non-Compliant",
                "Invited",
                { label: "Self-Registered", value: "Registered" },
                { label: "Registered", value: "Assigned" },
                { label: "Deactivated", value: "Closed" },
              ]}
              title={"Status"}
              updateFilter={updateFilter}
              fieldName={"provider_status"}
            />
          </div>
          <div>
            <SiteMultiSelectDropdown title={"Site"} updateFilter={updateFilter} />
          </div>
          <div>
            <DateMultiSelectDropdown
              title={"Completion date"}
              setKey={setKey}
              type={"completion_date_range"}
              dateMinMax={dateMinMax}
              updateFilter={updateFilter}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="flex gap-1 cstm-dropdown flex-wrap">
          <div>
            <MainOfficeStateMultiSelectDropdown title={"State"} updateFilter={updateFilter} />
          </div>
          <div>
            <ServiceMultiSelectDropdown title={"Services"} updateFilter={updateFilter} />
          </div>
          <div>
            <div className="relative flex items-center h-full w-56">
              <svg className="absolute left-3 w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
              <Input
                type="text"
                placeholder="Search Contact Name"
                name="client_contact_name"
                className="pl-9 py-2 h-[42px] w-full bg-white border-gray-300 rounded-md shadow-sm text-sm leading-5"
                inputchangehandler={(val) => debouncedContactNameSearch(val)}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="grid grid-cols-12 flex-wrap border border-gray-100 rounded-xl p-6 mt-5 gap-6 items-center justify-around"
      >
        <div className="col-span-6">
          <ProgressCircle chartData={reportData?.staticsGraph} />
        </div>
        <div className="col-span-6 mx-auto">
          <ActivityGauge chartData={reportData?.staticsGraph} />
        </div>
      </div>
      <DataList
        data={reportData}
        handleSort={handleSort}
        getAllinvitedData={getAllinvitedData}
        buildRowKey={buildRowKey}
        expandedRowKeys={expandedRowKeys}
        onToggleExpand={onToggleExpand}
        rowDetailsMap={rowDetailsMap}
        rowDetailsLoading={rowDetailsLoading}
        selectedRowKeys={selectedRowKeys}
        onToggleRow={onToggleRow}
        providerDocsByOrgId={providerDocsByOrgId}
        providerDocsLoadingByOrgId={providerDocsLoadingByOrgId}
      />
      <div className="flex justify-between mt-3">
        {reportData?.total > 0 && (
          <div className={!loadData ? "pointer-events-none opacity-60" : ""}>
            <Pagination
              totalCount={reportData?.total || 0}
              pageNumber={getAllinvitedData.page}
              displayPage={reportData?.DocsReport?.length || 0}
              UpdatePageLimit={SetgetAllinvitedData}
              allfilters={getAllinvitedData}
            />
          </div>
        )}
        {reportData?.total > 0 && (
          <ReactPaginate
            className={`flex justify-content-end p-2 align-items-center pagination-wrap ${!loadData ? "pointer-events-none opacity-60" : ""
              }`}
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLinkClassName={"prev-link"}
            nextLinkClassName={"page-link"}
            breakLinkClassName={"prev-link"}
            previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
            nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
            pageLinkClassName={"px-4 rounded-md"}
            activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
            disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
            renderOnZeroPageCount={null}
            forcePage={getAllinvitedData?.page - 1}
          />
        )}
      </div>

      {!loadData && (
        <div className="mt-4 flex justify-center">
          <ThreeDotBouncing />
        </div>
      )}
      <Dialog
        isOpen={pdfDownloadSuccessDialog}
        onClose={closeDownloadSuccessPdf}
        onRequestClose={closeDownloadSuccessPdf}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          {!checkPdfLoad && (
            <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
              <svg
                width="49"
                height="49"
                viewBox="0 0 49 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.894531"
                  y="0.585938"
                  width="48"
                  height="48"
                  rx="24"
                  fill="#D1FADF"
                />
                <path
                  d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          )}
          {checkPdfLoad && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            {checkPdfLoad
              ? "Provider Summary Report downloading.."
              : "Provider Summary Report downloaded successfully!"}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
        </div>
      </Dialog>

      {/* Dialogs for Custom reports */}
      <Dialog
        isOpen={unSaveDialogIsOpen}
        onClose={onDialogCloseUnSave}
        onRequestClose={onDialogCloseUnSave}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
            {saveCustomRep ? "Are you removing this custom report" : "Are you saving the custom report?"}

          </h4>
          {!saveCustomRep && (

            <div style={{ marginTop: "10px" }}>
              <Input
                className="h-9 w-full"
                placeholder="Type here"
                value={custReportName}
                name="message"
                inputchangehandler={(e) => inputChangeHandler(e)}
              />
              {custErrMsg && (
                <p className="text-xs text-red-600 mt-2">
                  {custErrMsg}
                </p>
              )}
            </div>
          )}
        </div>

        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onDialogCloseUnSave()} className="mr-1.5">
            Cancel
          </BtnLight>
          <BtnPrimary className="ml-1.5" onClick={() => handleCustom("compliance-checklist", " Providers Checklist Overview", saveCustomRep ? false : true, "createOrDelete")}>
            Confirm
          </BtnPrimary>
        </div>
      </Dialog>
      <Dialog
        isOpen={removeDilaog}
        onClose={onDialogCloseRemove}
        onRequestClose={onDialogCloseRemove}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
            {saveCustomRep && "Are you updating this custom report"}
          </h4>
        </div>

        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onDialogCloseRemove()} className="mr-1.5">
            Cancel
          </BtnLight>
          <BtnPrimary className="ml-1.5" onClick={() => handleCustom("compliance-checklist", " Providers Checklist Overview", true, "update")}>
            Confirm
          </BtnPrimary>
        </div>
      </Dialog>
      <Dialog
        isOpen={openSuccessDialog}
        onClose={onCloseDetails}
        onRequestClose={onCloseDetails}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9.5 16l2 2 4.5-4.5M14.5 2H9.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4.5 4.28 4.5 5.12 4.5 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.78 22 7.62 22 9.3 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8l-6-6z"
                stroke="#344054"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">

            {`Custom reports ${custSuccessMsg ? "updated" : "saved"}  successfully!`}
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnPrimary onClick={onCloseDetails}>Close</BtnPrimary>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default ProvidersComplianceChecklist;
